"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._FilterRule = {
    type: "structure",
    required: [],
    members: {
        Name: {
            shape: {
                type: "string"
            }
        },
        Value: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_FilterRule.js.map